module.exports = __webpack_public_path__ + "img/map_Z2.1.E.05.abb76822.svg";